<template>
  <v-list-item class="icon-message-wrapper">
    <template v-slot:prepend>
      <v-icon :color="color" size="x-large">
        {{ icon }}
      </v-icon>
    </template>

    {{ message }}
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IconWithMessage',
  props: {
    color: String,
    icon: String,
    message: String
  }
})
</script>

<style lang="scss" scoped>
.icon-message-wrapper {
  font-size: 1rem;

  @media (max-width: 599px), (max-height: 770px) {
    font-size: 0.8rem;
  }

  :deep(.v-list-item__prepend) > .v-icon {
    opacity: 1;
    ~ .v-list-item__spacer {
      width: 16px;
    }
  }
}
</style>
